import { Directive, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator } from '@angular/forms';

import { FormsValidators } from '../validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[greaterThan]',
  // eslint-disable-next-line no-use-before-define
  providers: [{ provide: NG_VALIDATORS, useExisting: GreaterThanValidatorDirective, multi: true }],
})
export class GreaterThanValidatorDirective implements Validator {
  @Input() public greaterThan: string | number;
  @Input() public greaterThanErrorKey = 'greaterThan';

  public validate(c: FormControl) {
    return FormsValidators.greaterThan(+this.greaterThan, this.greaterThanErrorKey)(c);
  }
}
